export const INDIVIDUAL_ITEM_SELECTION = 'INDIVIDUAL_ITEM_SELECTION'
export const RANGE_SELECTION = 'RANGE_SELECTION'
